import { render, staticRenderFns } from "./CarretArrow.vue?vue&type=template&id=2b56bc80&"
import script from "./CarretArrow.vue?vue&type=script&lang=js&"
export * from "./CarretArrow.vue?vue&type=script&lang=js&"
import style0 from "./CarretArrow.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports